import React from 'react';

import { Skeleton } from '@material-ui/lab';

import BaseSkeleton from '../BaseSkeleton';
import Card from '../../../Card';

import { OrderStatusStepperSkeletonProps } from './OrderStatusStepperSkeleton.types';

const OrderStatusStepperSkeleton: React.FC<OrderStatusStepperSkeletonProps> = ({ className }) => {
  return (
    <Card className={`relative flex flex-justify p4 ${className}`}>
      <div className="flex flex-column flex-space-around">
        <div className="flex flex-row flex-center mb2">
          <Skeleton variant="circle" height={18} width={18} className="mr2" />
          <BaseSkeleton width={150} height={25} />
        </div>
        <div className="flex flex-row flex-center mb2">
          <Skeleton variant="circle" height={18} width={18} className="mr2" />
          <BaseSkeleton width={150} height={25} />
        </div>
        <div className="flex flex-row flex-center mb2">
          <Skeleton variant="circle" height={18} width={18} className="mr2" />
          <BaseSkeleton width={150} height={25} />
        </div>
      </div>
      <div className="flex flex-column flex-grow flex-center">
        <BaseSkeleton width={120} height={25} className='mb2' />
        <BaseSkeleton width={120} height={25} className='mb2' />
        <BaseSkeleton width={120} height={25} className='mb2' />
      </div>
    </Card>
  );
};

export default OrderStatusStepperSkeleton;
export { OrderStatusStepperSkeletonProps };
